// import * as React from "react";
import React, { useState } from "react";
import Box from "@mui/material/Box";
import { BrowserRouter as Router, Link } from "react-router-dom";
import { styled, ThemeProvider, createTheme } from "@mui/material/styles";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import ArrowRight from "@mui/icons-material/ArrowRight";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import Home from "@mui/icons-material/Home";
import Settings from "@mui/icons-material/Settings";
import People from "@mui/icons-material/People";
import PermMedia from "@mui/icons-material/PermMedia";
import Dns from "@mui/icons-material/Dns";
import Public from "@mui/icons-material/Public";
import { Brand } from "../brand/NewBrand";
// import "./aside.css";
// import "./newaside.css";
import { useHistory } from "react-router-dom";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import userr from "../../../../../src/app/assests/user4.jpg";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import AddIcon from "@mui/icons-material/Add";
import Typography from "@mui/material/Typography";
import PeopleAltTwoToneIcon from "@mui/icons-material/PeopleAltTwoTone";
import PersonAdd from "@mui/icons-material/PersonAdd";
import ViewModuleIcon from "@material-ui/icons/ViewModule";
import Logout from "@mui/icons-material/Logout";
import DashboardTwoToneIcon from "@mui/icons-material/DashboardTwoTone";
// E:\DrashtiPatelBackend\gamerji-saas-leagueops\src\app\assests\user4.jpg

function stringToColor() {
  return "#9E9E9E"; // Grey color
}
function stringAvatar(name) {
  return {
    sx: {
      bgcolor: stringToColor(),
      color: "white", // Set font color to white
      width: "40px", // Set width
      height: "40px", // Set height
      fontSize: "20px", // Set font size
    },
    children: `${name.split(" ")[0][0]}${name.split(" ")[1][0]}`,
  };
}
const FireNav = styled(List)({
  "& .MuiListItemButton-root": {
    paddingLeft: 24,
    paddingRight: 24,
  },
  "& .MuiListItemIcon-root": {
    minWidth: 0,
    marginRight: 16,
  },
  "& .MuiSvgIcon-root": {
    fontSize: 20,
  },
});

const data = [{ icon: <ViewModuleIcon />, label: "Modules" }];
const Users = [{ icon: <PeopleAltTwoToneIcon />, label: "Staff User's" }];
const NewAside = ({ defaultOpen = true }) => {
  const [open, setOpen] = React.useState(defaultOpen);
  const [rolesAndPermissionsOpen, setRolesAndPermissionsOpen] = React.useState(
    false
  );
  const [dashboardOpen, setDashboardOpen] = React.useState(false); // Add state for Dashboard
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [activeModule, setActiveModule] = useState(null);
  const [activeSection, setActiveSection] = useState(null);
  const history = useHistory();
  const open1 = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleRolesAndPermissionsToggle = () => {
    setRolesAndPermissionsOpen(!rolesAndPermissionsOpen);
  };
  const [users, setUsers] = useState(false);

  const handleDropdownToggle = () => {
    setRolesAndPermissionsOpen(!rolesAndPermissionsOpen);
  };

  const handleDropdownToggleUsers = () => {
    setUsers(!users);
  };
  const handleDashboardToggle = () => {
    setRolesAndPermissionsOpen(false);
    setUsers(false);
    setDashboardOpen(!dashboardOpen);
    setActiveModule(null);
    setActiveSection(null);
    history.push("/dashboard");
  };
  const handleModuleClick = (item) => {
    setActiveModule(item.label);
    setActiveSection(item.label);
    history.push("/role-and-permissions/module/list");
    setRolesAndPermissionsOpen(true);
    setUsers(false);
    setDashboardOpen(false);
  };

  const handleModuleClickUser = (item) => {
    setActiveModule(null);
    if (item.label === "Staff User's") {
      history.push("/users/staff-user/list");
      setActiveSection(item.label);
      // Reset the state of other sections
      setUsers(true);
      setRolesAndPermissionsOpen(false);
      setDashboardOpen(false);
    }
  };

  const handleProfileClick = () => {
    window.open("user-profile/GSGJ000000002/GJ", "_blank");
  };
  const [isHovered, setIsHovered] = useState(false);
  const signOut = (value) => {
    localStorage.clear();
    window.location.reload();
  };
  return (
    <Box sx={{ display: "flex", maxWidth: 950 }}>
      <ThemeProvider
        theme={createTheme({
          components: {
            MuiListItemButton: {
              defaultProps: {
                disableTouchRipple: true,
              },
            },
          },
          palette: {
            mode: "dark",
            primary: { main: "rgb(102, 157, 246)" },
            background: { paper: "rgb(5, 30, 52)" },
          },
        })}
      >
        <Paper
          elevation={0}
          sx={{ maxWidth: 350, width: 350, borderRadius: 0 }}
        >
          <FireNav component="nav" disablePadding>
            {/* Brand */}
            <ListItemButton
              component="a"
              href="#customized-list"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Brand />
            </ListItemButton>
            <Divider />

            <Divider />

            <Box
              sx={{
                bgcolor: dashboardOpen ? "rgba(71, 98, 130, 0.2)" : null,
                // pb: dashboardOpen ? 2 : 0,
              }}
            >
              <ListItemButton
                alignItems="flex-start"
                sx={{
                  px: 3,
                  pt: 2.5,
                  pb: dashboardOpen ? 0 : 2.5,
                  color: "inherit",
                  // width: 250,
                  "&:hover, &:focus": {
                    "& svg": { opacity: dashboardOpen ? 1 : 0 },
                    bgcolor: "rgba(71, 98, 130, 0.2)",
                    color: "#fff",
                  },
                }}
                component={Link}
                to="/dashboard"
                onClick={handleDashboardToggle}
              >
                {/* <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer", // Add cursor pointer for hover effect
                  }}
                > */}
                  {/* <DashboardTwoToneIcon
                    style={{
                      marginRight: "8px",
                      opacity: 0.7, // Initial opacity
                      transition: "opacity 0.3s", // Smooth transition for opacity change
                      fontSize: "30px",
                    }}
                  /> */}
                  <div>
                    <ListItemText
                      primary="Dashboard"
                      primaryTypographyProps={{
                        fontSize: 15,
                        fontWeight: "medium",
                        lineHeight: "20px",
                        marginBottom: "2px", // Changed to camelCase from mb
                      }}
                    />
                  </div>
                {/* </div> */}
              </ListItemButton>
            </Box>
            <Divider />

            {/* Roles and Permissions */}
            <Box
              sx={{
                pb: rolesAndPermissionsOpen ? 2 : 0,
              }}
            >
              <ListItemButton
                alignItems="flex-start"
                onClick={handleDropdownToggle}
                sx={{
                  px: 3,
                  pt: 2.5,
                  pb: rolesAndPermissionsOpen ? 0 : 2.5,
                  display: "flex", // Ensure the container is displayed as flex
                  alignItems: "center", // Align items vertically
                  justifyContent: "space-between", // Spread items evenly along the horizontal axis
                  "&:hover, &:focus": {
                    "& svg": { opacity: 1 },
                  },
                }}
              >
                {/* <div style={{ display: "flex", alignItems: "center" }}>
                  <DashboardTwoToneIcon
                    style={{
                      marginRight: "8px",
                      opacity: 0.7, // Initial opacity
                      transition: "opacity 0.3s", // Smooth transition for opacity change
                      fontSize: "30px",
                    }}
                  /> */}
                  <ListItemText
                    primary="Roles and Permission"
                    primaryTypographyProps={{
                      fontSize: 15,
                      fontWeight: "medium",
                      lineHeight: "20px",
                      mb: "2px",
                    }}
                    secondary="Module"
                    secondaryTypographyProps={{
                      noWrap: true,
                      fontSize: 12,
                      lineHeight: "16px",
                      color: rolesAndPermissionsOpen
                        ? "rgba(0,0,0,0)"
                        : "rgba(255,255,255,0.5)",
                    }}
                    sx={{ my: 0 }}
                  />
                {/* </div> */}
                <KeyboardArrowDown
                  sx={{
                    mr: -1,
                    transform: rolesAndPermissionsOpen
                      ? "rotate(-180deg)"
                      : "rotate(0)",
                    transition: "0.2s",
                  }}
                />
              </ListItemButton>
              {rolesAndPermissionsOpen &&
                data.map((item) => (
                  <ListItemButton
                    key={item.label}
                    alignItems="center"
                    onClick={() => handleModuleClick(item)}
                    sx={{
                      px: 3,
                      pt: 2.5,
                      pb: rolesAndPermissionsOpen ? 0 : 2.5,
                      backgroundColor:
                        activeModule === item.label
                          ? "rgba(71, 98, 130, 0.2)"
                          : "transparent",
                      "&:hover, &:focus": {
                        "& svg": { opacity: 1 },
                      },
                    }}
                  >
                    <ListItemIcon
                      sx={{ color: "inherit", alignSelf: "flex-end" }}
                    >
                      {item.icon}
                    </ListItemIcon>
                    <ListItemText
                      primary={item.label}
                      primaryTypographyProps={{
                        fontSize: 14,
                        fontWeight: "medium",
                      }}
                    />
                  </ListItemButton>
                ))}
            </Box>

            <Divider />

            {/* Users */}
            <Box
              sx={{
                pb: users ? 2 : 0,
              }}
            >
              <ListItemButton
                alignItems="flex-start"
                onClick={handleDropdownToggleUsers}
                sx={{
                  px: 3,
                  pt: 2.5,
                  pb: activeSection ? 0 : 2.5,
                  display: "flex", // Ensure the container is displayed as flex
                  alignItems: "center", // Align items vertically
                  justifyContent: "space-between", // Spread items evenly along the horizontal axis
                  "&:hover, &:focus": {
                    "& svg": { opacity: 1 },
                  },
                }}
              >
                {/* <div style={{ display: "flex", alignItems: "center" }}>
                  <DashboardTwoToneIcon
                    style={{
                      marginRight: "8px",
                      opacity: 0.7, // Initial opacity
                      transition: "opacity 0.3s", // Smooth transition for opacity change
                      fontSize: "30px",
                    }}
                  /> */}
                  <ListItemText
                    primary="Users"
                    primaryTypographyProps={{
                      fontSize: 15,
                      fontWeight: "medium",
                      lineHeight: "20px",
                      mb: "2px",
                    }}
                    secondary="Staff Users"
                    secondaryTypographyProps={{
                      noWrap: true,
                      fontSize: 12,
                      lineHeight: "16px",
                      color: users ? "rgba(0,0,0,0)" : "rgba(255,255,255,0.5)",
                    }}
                    sx={{ my: 0 }}
                  />
                {/* </div> */}

                <KeyboardArrowDown
                  sx={{
                    mr: -1,
                    transform: users ? "rotate(-180deg)" : "rotate(0)",
                    transition: "0.2s",
                  }}
                />
              </ListItemButton>
              {users &&
                Users.map((item) => (
                  <ListItemButton
                    key={item.label}
                    alignItems="center"
                    onClick={() => handleModuleClickUser(item)}
                    sx={{
                      px: 3,
                      pt: 2.5,
                      pb: users ? 0 : 2.5,
                      backgroundColor:
                        activeSection === item.label // Check if activeSection matches the item's label
                          ? "rgba(71, 98, 130, 0.2)" // Highlight if active
                          : "transparent",
                      "&:hover, &:focus": {
                        "& svg": { opacity: 1 },
                      },
                    }}
                  >
                    <ListItemIcon
                      sx={{ color: "inherit", alignSelf: "flex-end" }}
                    >
                      {item.icon}
                    </ListItemIcon>
                    <ListItemText
                      primary={item.label}
                      primaryTypographyProps={{
                        fontSize: 14,
                        fontWeight: "medium",
                      }}
                    />
                  </ListItemButton>
                ))}
            </Box>

            <Divider />

            <ListItem component="div" disablePadding>
              <ListItemButton sx={{ height: 56 }}>
                <ListItemIcon>
                  <Stack direction="row" spacing={2}>
                    <Avatar alt="Valay Patel" src={userr} />
                  </Stack>
                </ListItemIcon>
                <ListItemText
                  primary="Valay Patel"
                  primaryTypographyProps={{
                    fontSize: 15,
                    fontWeight: "medium",
                    lineHeight: "20px",
                    mb: "2px",
                  }}
                  secondary="Chief technology officer"
                  secondaryTypographyProps={{
                    noWrap: true,
                    fontSize: 12,
                    lineHeight: "16px",
                    color: rolesAndPermissionsOpen
                      ? "rgba(0,0,0,0)"
                      : "rgba(255,255,255,0.5)",
                  }}
                  sx={{ my: 0 }}
                />
              </ListItemButton>
              <Tooltip title="Valay Patel">
                <React.Fragment>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                    }}
                  >
                    <Tooltip title="Account settings">
                      <IconButton
                        onClick={handleClick}
                        size="small"
                        sx={{ ml: 2 }}
                        aria-controls={open ? "account-menu" : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? "true" : undefined}
                      >
                        <Avatar
                          sx={{
                            width: 32,
                            height: 32,
                            backgroundColor: "grey",
                            color: "white",
                          }}
                        >
                          {" "}
                          <AddIcon />{" "}
                        </Avatar>
                      </IconButton>
                    </Tooltip>
                  </Box>
                  <Menu
                    anchorEl={anchorEl}
                    id="account-menu"
                    open={open1}
                    onClose={handleClose}
                    onClick={handleClose}
                    PaperProps={{
                      elevation: 0,
                      sx: {
                        overflow: "visible",
                        filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                        mt: -4.5,
                        "& .MuiAvatar-root": {
                          width: 32,
                          height: 32,
                          ml: -0.5,
                          ml: -0.5,
                          mr: 1,
                        },
                        "&::before": {
                          content: '""',
                          display: "block",
                          position: "absolute",
                          top: 0,
                          height: 10,
                          left: "250px !important",
                          bgcolor: "background.paper",
                          transform: "translateY(-50%) rotate(45deg)",
                          zIndex: 0,
                        },
                        left: 250, // Adjust this value to position the menu as desired
                      },
                    }}
                    transformOrigin={{ horizontal: "right", vertical: "top" }}
                    anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                  >
                    <MenuItem
                      onClick={handleProfileClick}
                      sx={{ display: "flex", alignItems: "center" }}
                    >
                      <Avatar src={userr} />
                      <span style={{ marginLeft: "8px" }}>Profile</span>
                    </MenuItem>

                    <Divider />

                    <MenuItem
                      onClick={signOut}
                      sx={{ display: "flex", alignItems: "center" }}
                    >
                      <ListItemIcon>
                        <Logout fontSize="medium" />
                      </ListItemIcon>
                      <span style={{ marginLeft: "8px" }}>Logout</span>
                    </MenuItem>
                  </Menu>
                </React.Fragment>
              </Tooltip>
            </ListItem>
          </FireNav>
        </Paper>
      </ThemeProvider>
    </Box>
  );
};

export default NewAside;
